import { combineReducers } from 'redux';
import { createReducer } from '@reduxjs/toolkit';
import { changeLocation } from '../actions';

export interface RoutingState {
  location: {
    url: string;
  };
}

// Kept as nested combineReducers (rather than a single slice) so that, like the
// original redux-actions version, the full { location: { url } } shape is always
// reconstructed even when called with a partial/empty state.
const urlReducer = createReducer('', (builder) => {
  builder.addCase(changeLocation, (_state, action) => action.payload.url);
});

export const routingReducer = combineReducers({
  location: combineReducers({
    url: urlReducer,
  }),
});
